import {SearchTypes} from "../../types/common/search.types";
import apiClient from '../apiClient';
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {RefundInfoType} from "../../types/transaction/refund.info.type";
import {RefundTypes} from "../../types/transaction/transaction.types";



export const getMemberRefundList = (searchData: SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/refund/getMemberRefundList",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getMemberRefundDetail = (refundRequestCode : string) =>
    apiClient.get<ResponseDto<RefundTypes>>("/api/front/refund/getMemberRefundDetail",
        {
            params: {refundRequestCode},
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getRefundFeeInfo = () =>
    apiClient.get<ResponseDto<RefundInfoType>>("/api/front/refund/getRefundFeeInfo");


export const refundPrepaidBalance = () =>
    apiClient.post<ResponseDto<any>>("/api/front/refund/refundPrepaidBalance");